export const INSURANCE_MARGIN_CONST = 2 / 7
export const BAGS_MARGIN_CONST = 10 / 12
